module.exports = __webpack_public_path__ + "img/warm-floor.b8579300.svg";